/**
 * OverviewSubTab - TASK-229/TASK-236/TASK-378
 * Compliance Overview composing dedicated sub-components:
 * - AlertsAndActions (priority alerts at top)
 * - FormStatusCards (form status in middle)
 * - UpcomingReviews + ActivityTimeline (side by side at bottom)
 */

import React from 'react';
import type { ComplianceSubTab } from '../ComplianceSubNav';
import { AlertsAndActions } from './AlertsAndActions';
import { FormStatusCards } from './FormStatusCards';
import { UpcomingReviews } from './UpcomingReviews';
import { ActivityTimeline } from './ActivityTimeline';

interface OverviewSubTabProps {
  clientId: string;
  onNavigateToSubTab: (tab: ComplianceSubTab) => void;
}

export const OverviewSubTab: React.FC<OverviewSubTabProps> = ({ clientId, onNavigateToSubTab }) => {
  return (
    <div className="space-y-6">
      {/* Priority Alerts — items requiring immediate attention */}
      <AlertsAndActions />

      {/* Form Status Cards — KYC, Client Profile, Form A, Risk Profile */}
      <FormStatusCards clientId={clientId} onNavigateToSubTab={onNavigateToSubTab} />

      {/* Two-column layout: Upcoming Reviews + Activity Timeline */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <UpcomingReviews />
        <ActivityTimeline />
      </div>
    </div>
  );
};

export default OverviewSubTab;
